// API 配置 - 从环境变量读取
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api'
const WS_URL = import.meta.env.VITE_WS_URL || 'ws://localhost:3001'

// 导出基础 URL（不带 /api 后缀，用于 socket.io 等）
export const API_HOST = API_BASE_URL.replace('/api', '')

// 导出完整 API URL
export const API_URL = API_BASE_URL

// 导出 WebSocket URL
export const WS_BASE_URL = WS_URL

export default {
  API_HOST,
  API_URL,
  WS_BASE_URL
}
